import withSyncContext from './withSyncContext';

export default withSyncContext;
